type CookieObject = { [key: string]: string };

export const parseCookies = (cookieString: string): CookieObject => {
    if (typeof cookieString !== 'string' || cookieString === '') {
        return {};
    }

    return cookieString.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split('=');
        if (key) {
            return { ...acc, [key.trim()]: value };
        }
        return acc;
    }, {});
};
